// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2m2mt","question":"Question_question__2onRi","description":"Question_description__3QBPu"};